import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { connect } from 'react-redux';
import { httpGet, crafterConf } from "@craftercms/classes";
import { composeUrl } from "@craftercms/utils";
import { languagePicker, removeIgnoreItems } from '../../utils';
import ListItem from '../../components/ListItem/ListItem';
import ProgramPageHolder from './ProgramPageStyles';
import queryString from 'query-string';
import SharePage from '../../components/SharePage/SharePage';
import { getLabel, smallerImage } from '../../utils';
import { useMediaQuery } from "react-responsive";
import NotFoundPage from "../FourOhFour/NotFoundPage";
import SEO from '../../components/SEO/SEO';

const ProgramPage = (props) => {
	const [cpacItemList, setCpacItemList] = useState([]);
	const [episode, setEpisode] = useState([]);
	const [program, setProgram] = useState([]);
	const [talents, setTalents] = useState([]);
	const [pageDesc, setPageDesc] = useState();
	const [nodata, setNodata] = useState(false);
	const locationState = useLocation();
	const siteURL = window.location.origin;
	const { pathname } = window.location;
	const [pageURL, setPageURL] = useState();
	const pageLang = props.current_lang;
	const pageLocale = pageLang + "_CA";
	const pageTitle = program.title ? program.title + " | CPAC.ca" : "CPAC.ca";

	// lg 768 (1536 retina), md 576 (1152 retina), sm 269 (538 retina)
	// full
	const is1090_ = useMediaQuery({ query: '(min-width: 1090px)' })
	const is769_920 = useMediaQuery({ query: '(min-width: 769px) and (max-width: 920px)' })
	// lg
	const is577_768 = useMediaQuery({ query: '(min-width: 577px) and (max-width: 768px)' })
	const is921_1089 = useMediaQuery({ query: '(min-width: 921px) and (max-width: 1089px)' })

	const isMd = useMediaQuery({ query: '(min-width: 270px) and (max-width: 576px)' })
	const isSm = useMediaQuery({ query: '(max-width: 269px)' })
	const imgSz = (is1090_ || is769_920) ? "full" : (is577_768 || is921_1089) ? "lg" : isMd ? "md" : isSm ? "sm" : null;

	useEffect(() => {
		//change for a better implementation /site/website/program/index.xml?id=covid-19--canada-responds
		let completeUrl = window.location.search;
		let params = queryString.parse(completeUrl);
		if (params.id) {
			const craftConf = crafterConf.getConfig();
			const serviceUrl = composeUrl(craftConf, process.env.REACT_APP_CONTENT_MODEL_ENDPOINT);

			httpGet(serviceUrl, { url: props.url, crafterSite: craftConf.site, "id": params.id }).subscribe((data) => {
				//console.log(data)
				//thumnail del programa del programa descripcion del programa 
				//nombre interno del programa -
				let fieldNames = ["itemList;title_t", "itemList.title_t", "itemList.description_t", "itemList.url_s",
					"itemList.image_s", "itemList.altImageTxt_s", "itemList;seeAllUrl_s",
					"talents.bios_html",
					"itemList.category_t", "itemList.categoryURL_s",
					"program;title_t", "program;description_t", "program;image_s", "program;altImageTxt_s",
					"episode;title_t", "episode;description_t", "episode;image_s", "episode;altImageTxt_s", "episode;url_s",]
				languagePicker(data, fieldNames);

				let dataPage = data.page;
				if (data.page.program.talents) {
					data.page.program.talents.item = removeIgnoreItems(data.page.program.talents)
				}
				setEpisode(dataPage.episode);
				setCpacItemList(dataPage.itemList);
				setProgram(dataPage.program);
				setPageDesc(data.page.program.description);
				if (dataPage.program.talents != null) {
					setTalents(dataPage.program.talents.item);
				}


			});
			httpGet(serviceUrl, { url: `/site/components/programs/${params.id}.xml`, crafterSite: craftConf.site }).subscribe(data => {
				if (data != null) { // check to see if the passed id is valid
					setNodata(false);
				} else {
					setNodata(true);
				}

			});
			setPageURL(siteURL + pathname + "?id=" + params.id);
		}
	}, [props.url, props.current_lang, locationState, siteURL, pathname]);

	useEffect(() => {
		props.setCurrentLanguage(props.lan);
	}, [props.lan]);

	const renderTalents = () => {
		return talents.map((result, i) => {
			return (
				<div className="host-bio" key={i} >
					<h2 className="pgm-about-host-label">{getLabel("HOST_BIO")}</h2>
					<h3 itemProp='actor' itemScope="itemscope" itemType='https://schema.org/Person'><span itemProp='givenName'>{result.first_name_s}</span> <span itemProp='familyName'>{result.last_name_s}</span></h3>
					<div itemProp='description' dangerouslySetInnerHTML={{ __html: props.current_lang === 'en' ? result.bios_en_html : result.bios_fr_html }}></div>
				</div>
			)
		});
	}

	const renderContent = () => {

		if (episode) {
			return (
				<a href={episode.url}>
					{program.image ? <img src={smallerImage(program.image, imgSz)} alt={program.altImageTxt} itemProp='thumbnailUrl' /> : ""}
					<div className="show-latest-episode" itemProp='episode'>
						<div className="latest-episode-thumbnail">
							{episode.image ? <img src={smallerImage(episode.image, "sm")} alt={episode.altImageTxt} itemProp='thumbnailUrl' /> : ""}
						</div>
						<div className="latest-episode-info">
							<div className="play-button-watch-title">
								<button name="play"><span className="screen-reader-text">{getLabel("PLAY")}</span></button>
								<h2 tabIndex="0">{getLabel("WATCH_LATEST_EPISODE")}</h2>
							</div>
							<span tabIndex="0" itemProp='name'>{episode.title}</span>
						</div>
					</div>
				</a>
			)
		} else {
			if (program.image) {
				return <img src={smallerImage(program.image, imgSz)} alt={program.altImageTxt} itemProp='thumbnailUrl' />
			} else {
				return null
			}
		}
	}
	if (nodata) {
		return <NotFoundPage />
	}
	return (
		<>
			<SEO pageDesc={pageDesc} pageURL={pageURL} title={program.title} pageTitle={pageTitle} image={siteURL + program.image} type="video.tv_show" pageLocale={pageLocale} />
			<ProgramPageHolder>
				<div itemScope itemType='https://schema.org/TVSeries'>
					<h1 className="page-title" tabIndex="0" itemProp='headline'>{program.title}</h1>
					<div className="content-wrapper">
						<div className="show-thumbnail content__left" itemProp='mainEntity'>
							{renderContent()}
							<div className="show-title-description" tabIndex="0" itemProp='about'>
								<p dangerouslySetInnerHTML={{ __html: program.description }}></p>
							</div>
							<div className="social-share">
								<SharePage />
							</div>

							{talents.length > 0 &&
								<div className="pgm-aboutHost">{renderTalents()}</div>
							}
						</div>
						<div className="content__right" itemScope itemType='https://schema.org/WPSideBar'>
							{cpacItemList && <ListItem items={cpacItemList} />}
						</div>
					</div>
				</div>
			</ProgramPageHolder>
		</>
	)
}

const mapStateToProps = (store) => ({
	current_lang: store.language.current,
});

const mapDispatchToProps = (dispatch) => ({
	setCurrentLanguage: (lang) => dispatch({ type: 'SET_CUR_LANG', current: lang })
});

export default connect(mapStateToProps, mapDispatchToProps)(ProgramPage);